import type { ContentSmartLinksQuery_contentSmartLinks_nodes } from './__types__/ContentSmartLinksQuery';
// We are currently only SSRing inline Smart Links, all other types of Smart Links will be ignored
export const isInlineSmartLink = (node: any): boolean => {
	return node?.['__typename'] === 'InlineSmartLink';
};

export type SmartLinkType = {
	appearance: string;
	resourceUrl: string;
};

const parseSmartlinksResponse = (
	res: any,
	isDraft: boolean,
): ContentSmartLinksQuery_contentSmartLinks_nodes[] => {
	if (isDraft) {
		return res?.data?.confluence_contentSmartLinksForDraft?.nodes || [];
	}
	return res?.data?.contentSmartLinks?.nodes || [];
};

// This function takes in a query response and returns an array of SmartLink resourceUrls
export const getSmartLinks = (res: any, isDraft = false): SmartLinkType[] => {
	const content = parseSmartlinksResponse(res, isDraft);

	// filter to only inline smartlins and limit to the max number of smartlinks allowed per call by ORS
	const inputSmartLinks = content.filter(isInlineSmartLink).slice(0, 50);

	return inputSmartLinks.map((node) => {
		return {
			appearance: 'inline',
			resourceUrl: node?.url,
		};
	});
};
